import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { stopLoading } from '@/__core/redux/globalLoadingSlice';
import { clearRequestLoading as clearOrdersLoading } from '@/modules/orders/redux/OrderRedux';
import { clearRequestLoading as clearCompanyLoading } from '@/modules/organizations/redux/CompanyRedux';
import { clearRequestLoading as clearDepartmentLoading } from '@/modules/organizations/redux/DepartmentRedux';
import * as employee from '@/modules/employees/redux/EmployeeRedux';
import { resetModuleSessionFlags } from './resetModuleSessionFlags';

/**
 * Runs on every pathname change: clear stuck global loading and module fetch caches.
 */
export default function RouteChangeCleanup() {
  const location = useLocation();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(stopLoading(undefined));
    dispatch(clearOrdersLoading());
    dispatch(clearCompanyLoading());
    dispatch(clearDepartmentLoading());
    dispatch(employee.actions.failEmployees(''));
    resetModuleSessionFlags();
  }, [location.pathname, dispatch]);

  return null;
}
